import styled from "styled-components";

export const ModalContainer = styled.div<{ isOpen: boolean }>`
    display: ${({ isOpen }) => (isOpen ? "block" : "none")};
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100000;
    background-color: rgba(0, 0, 0, 0.8);

    #close-icon {
        position: absolute;
        right: 50px;
        top: 50px;
        cursor: pointer;
        font-size: 30px;
    }

    transition: 200ms translate ease-in-out;
`;

export const InnerWrapper = styled.div`
    padding: 10px;
    border-radius: 10px;
    min-width: 300px;
    position: absolute;
    background-color: #fff;
    top: 50%;
    left: 50%;
    display: flex;
    flex-direction: column;
    transform: translate(-50%, -50%);
    transition: 200ms translate ease-in-out;
`;
